// extracted by mini-css-extract-plugin
export default {"wrapperBtnChannel":"AddChannel_wrapperBtnChannel__DYxYv"};